import { Context } from "../../App";
import HeaderWebsite from "../../components/HeaderWebsite";
import DashboardUsers from "../../components/DashboardUsers";

export default function DashboardUsersPage(props) {
  const {
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    userData,
  } = props;

  return (
    <>
      <HeaderWebsite
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
        userData={userData}
        user={userData}
      />
      <Context.Provider value={{ statusMode }}>
        <DashboardUsers />
      </Context.Provider>
    </>
  );
}
